import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import routes from './config/Routes';
import './sass/index.scss';

function App() {
	return (
		<Router>
			<Switch>
				{routes.map((route, index) => (
					<RouteWithSubRoutes key={index} {...route} />
				))}
			</Switch>
		</Router>
	);
}

export default App;

function RouteWithSubRoutes(route) {
	return (
		<Route
			path={route.path}
			exact={route.exact}
			render={(props) => <route.component routes={route.routes} {...props} />}
		/>
	);
}
